/** Shared formatting for the ADOC viewer's table and document list. */

export function formatBytes(bytes: number | null): string {
    if (!bytes || bytes <= 0) {
        return '—';
    }
    const units = ['B', 'KB', 'MB', 'GB'];
    const exponent = Math.min(units.length - 1, Math.floor(Math.log(bytes) / Math.log(1024)));
    const value = bytes / Math.pow(1024, exponent);
    return `${value.toFixed(value >= 10 || exponent === 0 ? 0 : 1)} ${units[exponent]}`;
}

export function formatDate(iso: string | null): string {
    if (!iso) {
        return '—';
    }
    const date = new Date(iso);
    return Number.isNaN(date.getTime()) ? '—' : date.toLocaleDateString();
}

export function formatDateTime(iso: string | null): string {
    if (!iso) {
        return '—';
    }
    const date = new Date(iso);
    return Number.isNaN(date.getTime()) ? '—' : date.toLocaleString();
}

export function daysUntil(iso: string | null): number | null {
    if (!iso) {
        return null;
    }
    const target = new Date(iso);
    if (Number.isNaN(target.getTime())) {
        return null;
    }
    const start = new Date();
    start.setHours(0, 0, 0, 0);
    target.setHours(0, 0, 0, 0);
    return Math.round((target.getTime() - start.getTime()) / 86_400_000);
}
